<div class="container-fluid p-0">
    <div id="loader" *ngIf="enableLoader"></div>
    <div *ngIf="!enableLoader">
        <div class="mb-0 py-4 border-bottom" style="background: #F8F9FA;">
            <div class="container ">
                <div class="row" *ngFor="let consigndetails of consignDetails;let i= index;">
                    <div class="col-md-10">
                        <breadcrumb #parent>
                            <ol class="breadcrumb ml-1 p-0 mb-1 text-secondary">
                                <li class="breadcrumb-item">
                                    <a (click)="homeLinkClick(true)" [routerLink]="['']">BHP Connect</a>
                                </li>
                                <li class="breadcrumb-item">
                                    <a (click)="homeLinkClick(true)" [routerLink]="['']">{{navigationData}}</a>
                                </li>
                            </ol>
                        </breadcrumb>
                        <h1 class="breadcrumb-page strong">{{title}}</h1>
                    </div>
                    <div class="col-md-2 d-none d-md-block d-lg-block ">
                        <h5 class="breadcrumb-page">{{consigndetails?.consignmentNumber}}</h5>
                    </div>

                </div>

            </div>
        </div>

        <div class="mb-0 py-4 border-bottom" style="background: #F8F9FA;">
            <div class="container">
                <a class="strong  text-primary" (click)="backtoshipment()">
                    < {{ "home.quote.Backtolist" | cxTranslate }}</a>
            </div>
        </div>
         <div class="container mt-5" *ngFor="let consigndetails of consignDetails;let i= index;">
            <div class="row">
            <div class="col-12 col-md-3 mb-3">
                <div class="text-secondary fs-14">Destination</div>
                <div class="strong fs-16">{{consigndetails.shippingDestination}}</div>
            </div>
            <div class="col-12 col-md-3 mb-3">
                <div class="text-secondary fs-14">Material</div>
                <div class="strong fs-16">{{consigndetails.materialDescription}}</div>
            </div>
            <div class="col-12 col-md-1 mb-3 ">
                <div class="text-secondary fs-14">Quantity(ST)</div>
                <div class="strong fs-16">{{consigndetails.quantity}}</div>
            </div>
            <div class="col-12 col-md-2 mb-3">
                <div class="text-secondary fs-14">Contract ID</div>
                <div class="strong fs-16">{{consigndetails.contractID}}</div>
            </div>
            <div class="col-12 col-md-1 mb-3">
                <div class="text-secondary fs-14">ETAD</div>
                <div class="strong fs-16">{{consigndetails.etadDate}}</div>
            </div>
              <div class="col-12 col-md-2 mb-3" *ngIf="consigndetails?.purchaseOrderNo">
                <div class="text-secondary fs-14">External reference no</div>
                <div class="strong fs-16">{{consigndetails.purchaseOrderNo}}</div>
            </div>
            </div>
        </div>
        <div class="container py-4 pl-0">
            <div class="">
                <div class="row d-flex ml-0 mr-0 ">
                    <div class="col-sm-12 col-md-12">
                        <div class="border rounded p-4" style="background: #F8F9FA;">
                            <div class="text-secondary strong f-18">Documents</div>
                            <div class="row pt-4 pb-2">
                                <div class="col-12" *ngIf="docuMents && docuMents.length === 0 && !enableLoader">
                                    <div class="text-center strong text-secondary my-5">
                                        {{'home.contracts.Noresults' | cxTranslate }}
                                    </div>
                                </div>
                                <div class="col-md-5 col-lg-3 mb-3" *ngFor="let consigndocdetails of docuMents;">
                                    <div (click)="donwloadReport(consigndocdetails)" class="pe-auto">
                                        <img src="/images/download_orange.svg" alt="customlogo" width="25px" height="25px"> 
                                        &nbsp; 
                                        <span class="text-primary strong">{{consigndocdetails.documentName}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>